/**
 * Collection FAQ accordion.
 * The answer content is never added/removed/hidden via JS -- it's always
 * present in the DOM (see the CSS: grid-template-rows animates the visible
 * height, nothing sets display:none). This script only toggles a class and
 * updates aria-expanded for assistive tech; search engine crawlers see the
 * full text regardless of this script running at all.
 */
(function () {
    function initFaq(section) {
        section.querySelectorAll('.cfaq-item__question').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var item = btn.closest('.cfaq-item');
                var isOpen = item.classList.contains('is-open');
                item.classList.toggle('is-open', !isOpen);
                btn.setAttribute('aria-expanded', String(!isOpen));
            });
        });
    }

    document.querySelectorAll('.cfaq-section').forEach(initFaq);
})();
